'use client';

import { ComponentProps, MouseEvent } from 'react';
import { BaseLink } from '@/navigation';
import { AdViewSource, stashAdViewSource } from '@/utils/adViewSource';

type Props = ComponentProps<typeof BaseLink> & { adViewSource?: AdViewSource };

export function AdViewSourceLink({ adViewSource, onClick, ...props }: Props) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (adViewSource) {
      stashAdViewSource(adViewSource);
    }
    onClick?.(event);
  };

  return <BaseLink prefetch={props.target === '_blank' ? false : undefined} {...props} onClick={handleClick} />;
}
